export default Object.freeze({
  TABLE_TIT: '쇼핑몰 기본정보',
  TABLE_TIT_DISCLAIMER: '* 필수입력',
  MALL_NOTICE1_1: '쉽고 빠른 등록을 위해 쇼핑몰 신규 등록시 ',
  MALL_NOTICE1_2: '간소화된 항목',
  MALL_NOTICE1_3: '을 제공합니다.',
  MALL_NOTICE2_1: '등록 이후 ',
  MALL_NOTICE2_2: '[서비스 관리 -> 쇼핑몰 관리 -> 쇼핑몰 수정]',
  MALL_NOTICE2_3: '페이지에서 운영과 관련된 세부 설정 사항들을 수정하여 관리할 수 있습니다.',
  SHOPPING_MALL_MODIFICATION: '쇼핑몰 수정',
  MALL_NAME: '쇼핑몰명',
  MALL_NO: '쇼핑몰번호',
  LANGUAGE: '언어',
  MALL_COUNTRYCD: '판매대상국가',
  MALL_COUNTRYCD_NONE: '국가 선택',
  MALL_COUNTRYCD_KR: '대한민국 (KRW)',
  MALL_COUNTRYCD_US: '미국(대륙) (USD)',
  MALL_COUNTRYCD_U2: '미국(알래스카,하와이) (USD)',
  MALL_COUNTRYCD_JP: '일본 (JPY)',
  MALL_COUNTRYCD_CN: '중국 (CNY)',
  MALL_TIMEZONE: '시간대 선택',
  TIMEZONE_NONE: '시간대 선택',
  TIMEZONE_ASIA_SEOUL: 'UTC+9 대한민국・일본',
  TIMEZONE_GMT_Z: 'UTC+0',
  TIMEZONE_AMERICA_EASTERN: 'UTC-5 미국 Eastern',
  TIMEZONE_AMERICA_CENTRAL: 'UTC-6 미국 Central',
  TIMEZONE_AMERICA_MOUNTAIN: 'UTC-7 미국 Mountain',
  TIMEZONE_AMERICA_PACIFIC: 'UTC-8 미국 Pacific',
  EXCHANGE_INFO: '사용 화폐/환율',
  CURRENCY: '화폐',
  EXCHANGE_RATE_SETTING: '환율 설정',
  MAXIMUM_ORDER_AMOUNT: '국가별 최대 주문금액',
  MAXIMUM_ORDER_AMOUNT_DESCRIPTION_1: '국가별로 주문 가능한 최대 주문금액을 설정하실 수 있습니다.',
  MAXIMUM_ORDER_AMOUNT_DESCRIPTION_2: '쇼핑몰에서 주문 시 설정한 배송지 국가 기준으로 주문금액이 제한됩니다.',
  MALL_USE: '사용여부',
  MALL_USED: '사용함',
  MALL_USELESS: '사용 안 함',
  MALL_URL: '쇼핑몰 도메인 정보',
  MALL_PCURL: 'PC 웹 도메인',
  MALL_MOURL: '모바일 웹 도메인',
  MALL_AOSURL: 'AOS 모바일 앱 정보',
  MALL_IOSURL: 'iOS 모바일 앱 정보',
  MALL_APPTOKEN: '모바일앱 관리',
  WEB_OPEN: '바로가기',
  APP_OPEN: '앱 정보보기',
  URL_PLACEHOLDER: '20자 이내로 기입해주세요.',
  MOVE_TO_URL: '신청하기',
  CONTRACT_FILES: '국내 사업자 계약 서류 관리',
  CONTRACT_FILES_HIGHLIGHT1:
    'ⓘ ‘사업자등록증’, ‘통장사본‘, ‘법인인감증명서’ 를 제외한 계약 서류를 등록해주세요. (최대 7개)',
  CONTRACT_FILES_HIGHLIGHT2: 'ⓘ 등록된 계약 서류는 파트너사에서 확인 후, 필수 사항으로 등록합니다.',
  CONTRACT_FILES_HIGHLIGHT3:
    'ⓘ 파일은 문서(doc, docx, xls, xlsx), 이미지(jpg, jpeg, gif, png, pdf) 파일 등록이 가능하며,용량은 1개/10MB 미만 입니다.',
  CONTRACT_FILES_HIGHLIGHT4: 'ⓘ 안내 사항은 최대 1,000자까지 입력할 수 있습니다.',
  CONTRACT_FILES_HIGHLIGHT5: 'ⓘ ‘계좌증빙서류‘ 를 제외한 계약 서류를 등록해주세요. (최대 7개)',
  CONTRACT_FILES_TITLE: '계약 서류',
  CONTRACT_FILES_LABEL: '서류',
  CONTRACT_FILES_FIND: '파일찾기',
  CONTRACT_FILES_DOWNLOAD: '다운로드',
  CONTRACT_FILES_GUIDE: '안내 사항',
  CONTRACT_FILES_GUIDE_DESCRIPTION1: '- 서류 명칭은 최소 1자부터 최대 30자까지 입력이 가능합니다.',
  CONTRACT_FILES_GUIDE_DESCRIPTION2: '- 공백 포함 숫자,한글,영문 대/소문자 가능합니다.(특수 문자 입력 불가)',
  CONTRACT_FILES_GUIDE_DESCRIPTION3: '- 서류 명칭이 입력되지 않은 경우 저장이 불가능합니다.',
  CONTRACT_FILES_GUIDE_DESCRIPTION4: '- 서류 명칭을 입력하더라도 서류를 등록하지 않은 경우 저장이 불가능합니다.',
  CONTRACT_FILES_PLACEHOLDER:
    '파트너사의 계약 서류 작성 시, 파트너사 안내 사항을 입력하세요.(최대 1,000자)\n(ex. 인감 날인된 계약서 원본은 우편으로 발송해주세요. 발송 주소: OOO)',
  CONTRACT_FILES_OVERSEAS: '해외 사업자 계약 서류 관리',
  BANK_TITLE: '쇼핑몰 계좌정보',
  BANK_ACCOUNT: '계좌번호',
  BANK_PLACEHOLDER: '숫자만 입력하세요',
  BANK_DEPOSITORNAME: '예금주명',
  EMAIL_SEND_USE_CONFIG: 'e-mail 발송 사용 설정',

  EMAIL_SETUP_GUIDE: `[사용 설정 안내]\n
      ⓘ e-mail 발송 기능을 사용하시려면, 아래 항목을 '사용함'으로 설정해주세요.`,
  EMAIL_FARE_GUIDE_TITLE: '[e-mail 수동발송과 자동발송 및 요금안내]',
  EMAIL_FARE_GUIDE_CONTENT1: 'ⓘ e-mail은 수동발송과 자동발송으로 사용이 가능합니다.',
  EMAIL_FARE_GUIDE_CONTENT2: 'ⓘ e-mail 자동발송 금액은 기본적으로 NHN커머스에서 부담합니다.',
  EMAIL_FARE_GUIDE_CONTENT3: 'ⓘ e-mail 수동발송 금액은 NHN Cloud 이용금액에 포함되어 청구됩니다.',
  EMAIL_APPKEY_GUIDE: `[Appkey 설정 안내]\n
      ⓘ e-mail 수동발송 기능을 사용하시려면, NHN Cloud 프로젝트의 e-mail Appkey를 등록해 주셔야 합니다.\n
      ⓘ Appkey는 'NHN Cloud>CONSOLE>프로젝트 설정' 에서 확인 가능합니다.
    `,
  SEND_MAIL_DOMAIN_GUIDE_TITLE: '[발신 메일 도메인 등록 및 인증]',
  SEND_MAIL_DOMAIN_GUIDE_CONTENT1:
    'ⓘ <a href="https://support.google.com/mail/answer/81126" target="_blank" rel="noreferrer">Gmail 발신자 가이드라인</a>에 따라 도메인 인증, SPF 인증, DKIM 인증 및 활성화, DMARC 인증을 하지 않은 발신 도메인은 gmail.com, yahoo.com으로의 메일 발송 요청이 제한됩니다.',
  SEND_MAIL_DOMAIN_GUIDE_CONTENT2:
    'ⓘ 네이버(Naver), 지메일(Gmail) 등 이메일 서비스를 제공하는 업체의 도메인이 아닌 개인 또는 회사에서 소유한 도메인을 발신 도메인으로 사용하시는 경우, 도메인에 대한 모든 인증이 완료되어야 정상적인 이메일 서비스 이용이 가능하니, 사용하시는 발신 메일 도메인을 등록하고 인증해주시기 바랍니다.',
  SEND_MAIL_DOMAIN_GUIDE_CONTENT3:
    'ⓘ 수동발송 메일 도메인 인증 관리는 \'NHN Cloud>CONSOLE>프로젝트 설정\' 에서 가능합니다.',
  SEND_MAIL_DOMAIN_GUIDE_CONTENT4: 'ⓘ 자동발송 메일 도메인 인증 관리는 ‘운영관리 > e-mail 관리’ 에서 가능합니다.',

  SMS_TIT: 'SMS 발송',
  SMS_APPKEY: 'SMS Appkey',
  SMS_APPKEY_DESCRIPTION: 'SMS Appkey가 등록되어 있어야 SMS 유료항목 자동발송과 SMS 수동발송이 가능합니다.',
  SMS_APPKEY_PLACEHOLDER: 'SMS Appkey를 입력해주세요.',
  SMS_SENDER: '자동 SMS 발신번호',
  SMS_SENDER_PLACEHOLDER: '발신번호를 등록해주세요.',
  SMS_SENDER_ADD: '발신번호 등록/내역',
  SMS_SENDER_DESCRIPTION: '발신번호가 등록되어있어야 자동SMS(무료항목) 발송이 가능합니다.',
  NOTIFICATION_EMAIL_USED_ALERT: 'SMS발송 사용안함을 하여도 이전에 사용하신 금액은 청구될 수 있습니다.',
  NOTIFICATION_EMAIL_UNUSED_ALERT: 'e-mail 발송 과 SMS 발송 중 하나의 서비스는 사용 중이어야합니다.',
  EMAIL_TIT: 'e-mail 발송',
  EMAIL_APPKEY: 'e-mail Appkey',
  EMAIL_APPKEY_PLACEHOLDER: 'e-mail Appkey를 입력해주세요.',
  EMAIL_APPKEY_DESCRIPTION: 'e-mail Appkey가 등록되어 있어야 e-mail 수동발송이 가능합니다.',
  SERVICE_CENTER_TIT: '고객센터 정보',
  SERVICE_CENTER_HIGHLIGHT1: 'ⓘ 고객센터 전화번호는 발신번호 인증이 가능한 전화번호를 입력해주세요.',
  SERVICE_CENTER_HIGHLIGHT2:
    'ⓘ 고객센터 e메일주소는 수신용 e메일주소와 발송전용 e메일 주소 설정을 따로 하실 수 있습니다.',
  SERVICE_CENTER_HIGHLIGHT3: 'ⓘ e메일 발송 시, 설정한 쇼핑몰명과 함께 보여집니다. ex) 바이와우 <noreply@nhn.com>',
  SERVICE_CENTER_HIGHLIGHT4: 'ⓘ 발신 이메일 주소 변경 필요한 경우 메일 도메인 등록 및 인증 후 수정해 주시기 바랍니다.',
  SERVICE_CENTER_PHONENO: '고객센터 전화번호',
  SERVICE_CENTER_EMAIL: '고객센터 e메일 주소',
  SERVICE_CENTER_OUTBOUNDEMAIL: '발송전용 e메일 주소',
  SERVICE_CENTER_EMAILCOPY: '\'고객센터 e메일\'과 동일',
  ERROR: '입력형식이 잘못되었습니다',
  WMS_FAIL: 'WMS 연동재고 미만 시, 안전재고 개수와 같거나 큰 수를 입력해주세요.',
  JOINCONFIG_TIT: '회원 인증 설정',
  JOIN_CONFIG: '회원 설정',
  SETTING_DORMANT_MEMBER: '휴면회원 사용여부 설정',
  USABLE_DORMANT_MEMBER: '휴면회원 사용여부',
  DORMANT_SETTING_DESCRIPTION_1:
    'ⓘ 2023년 9월 15일 개인정보보호법 개정에 따라 \'개인정보 유효기간제\'가 폐지되어 업체 운영방침에 따라 자율적으로 휴면회원 배치 사용여부를 설정할 수 있습니다.',
  DORMANT_SETTING_DESCRIPTION_2:
    'ⓘ 휴면회원 기능을 \'사용 안 함\'으로 설정 시 다음 휴면전환 처리 시점에 휴면회원 처리 대상자도 휴면 처리되지 않습니다. 단, 기존 처리된 휴면회원에 대해서는 영향이 없습니다.',
  DORMANT_SETTING_DESCRIPTION_3:
    'ⓘ 휴면회원 기능을 \'사용 안 함\'으로 설정 시 SMS/알림톡/이메일 사용설정 여부와 상관없이 휴면전환사전안내 알림 발송이 되지 않습니다.',

  MALLJOINCONFIG_TH: '쇼핑몰회원',
  MALLJOINCONFIG_USED: '인증 사용여부',
  MALLJOINCONFIG_TYPE: '인증종류 설정',
  MALLJOINCONFIG_TYPE_PHONE: '휴대폰인증',
  MALLJOINCONFIG_TYPE_SMS: 'SMS인증',
  MALLJOINCONFIG_TYPE_EMAIL: '이메일인증',
  MALLJOINCONFIG_TYPE2: '인증 시점 설정',
  MALLJOINCONFIG_TYPE2_JOIN_TIME: '회원가입시',
  MALLJOINCONFIG_TYPE2_PAYMENT_TIME: '최초상품구매시',
  MALLJOINCONFIG_TYPE2_AFTER_JOIN_TIME: '가입완료시',
  OPENIDJOINCONFIG_TH: '오픈아이디회원',
  MALLJOIN_CONFIG_AUTHENTICATION_BY_PHONE_CONFIRM:
    '변경 시, 더 이상 휴대폰인증으로 회원가입 설정이 되지 않으며,\n재가입 불가 처리한 회원은 다시 가입이 가능하게 됩니다. 변경하시겠습니까?',
  MALLJOIN_CONFIG_SMS_OCCUPANCY_AUTHENTICATION_CONFIRM:
    '변경 시, 더 이상 SMS 인증으로 회원가입 설정이 되지 않습니다. 변경하시겠습니까?',
  MALLJOIN_CONFIG_AUTHENTICATION_BY_EMAIL_CONFIRM:
    '변경 시, 더 이상 이메일인증으로 회원가입 설정이 되지 않습니다. 변경하시겠습니까?',
  OPENIDJOIN_CONFIG_AUTHENTICATION_BY_PHONE_CONFIRM:
    '변경 시, 더 이상 휴대폰인증으로 회원가입 설정이 되지 않습니다. 변경하시겠습니까?',
  OPENIDJOIN_CONFIG_SMS_OCCUPANCY_AUTHENTICATION_CONFIRM:
    '변경 시, 더 이상 SMS 인증으로 회원가입 설정이 되지 않습니다. 변경하시겠습니까?',
  OPENIDJOIN_CONFIG_AUTHENTICATION_BY_EMAIL_CONFIRM:
    '변경 시, 더 이상 이메일인증으로 회원가입 설정이 되지 않습니다. 변경하시겠습니까?',
  INSTAGRAM_TIT: '인스타그램 연동',
  INSTAGRAM_TH: '인스타그램',
  INSTAGRAM_INTEGRATION: '인스타그램 연동',
  INSTAGRAM_DE_INTEGRATION: '인스타그램 연동 해제',
  SNS_JOINCONFIG_TIT: 'SNS 간편 회원가입 설정',
  SNS_JOINCONFIG_HIGHLIGHT1:
    'ⓘ SNS 계정으로 쇼핑몰 회원가입을 할 수 있도록 설정할 수 있습니다.',
  SNS_JOINCONFIG_HIGHLIGHT2: 'ⓘ [서비스 관리 > 외부 서비스 설정 > 간편로그인 연동] 메뉴에서도 설정할 수 있으며, 설정 값이 자동 연동되어 두 메뉴에 노출됩니다.',
  SNS_JOINCONFIG_HIGHLIGHT3:
    'ⓘ 카카오 싱크를 연동하실 경우 카카오 로그인은 자동으로 사용 제외 처리 되어 회원 가입 시 카카오 싱크 API로 설정됩니다.',
  SNS_JOINCONFIG_LOGIN_URL1:
    'ⓘ 연동하려는 인증업체의 개발자 센터에서 서비스 URL (PC웹, 모바일웹), Callback URL을 정확히 입력하지 않는 경우 연동이 불가합니다.',
    SNS_JOINCONFIG_LOGIN_URL2: 'ⓘ 기본 스킨(오로라) 사용 시 연동하려는 인증업체 개발자센터에 Callback URL을 \'https://쇼핑몰도메인/callback/auth-callback\'으로 입력하시기 바랍니다.',
  SNS_JOINCONFIG_LOGIN_URL2_EXIST:
    'ⓘ 기본 스킨 사용 시 사용중인 기본스킨에 따라 연동하려는 인증업체 개발자센터에 Callback URL을 다음과 같이 입력하시기 바랍니다.',
  SNS_JOINCONFIG_LOGIN_URL2_1_EXIST: '어나더, 오로라 - 개별형 스킨은 PC와 모바일 각각 총 2개의 Callback URL을 입력하셔야 합니다.',
  SNS_JOINCONFIG_LOGIN_URL2_1_1_EXIST: 'PC: https://쇼핑몰도메인/callback/auth-callback.html',
  SNS_JOINCONFIG_LOGIN_URL2_1_2_EXIST: '모바일 도메인 m. 을사용하는 경우 : https://m.쇼핑몰도메인/callback/auth-callback.html',
  SNS_JOINCONFIG_LOGIN_URL2_1_3_EXIST: '모바일 도메인 m- 를사용하는 경우 : https://m-쇼핑몰도메인/callback/auth-callback.html',
  SNS_JOINCONFIG_LOGIN_URL2_1_4_EXIST: '모바일 도메인 /m 을 사용하는 경우 : https://쇼핑몰도메인/m/callback/auth-callback.html',
  SNS_JOINCONFIG_LOGIN_URL2_2_EXIST: '오로라 리액트',
  SNS_JOINCONFIG_LOGIN_URL2_2_1_EXIST: 'PC, 모바일: https://쇼핑몰도메인/callback/auth-callback',
  SNS_JOINCONFIG_LOGIN_URL3: 'ⓘ 기본 스킨 외 별도로 구매한 스킨의 경우 스킨 제작사에 문의바랍니다.',
  SNS_JOINCONFIG_LOGIN_URL4: 'ⓘ 헤드리스 운영방식을 사용중인 경우 사용중인 Callback URL을 입력하시기 바랍니다.',
  SNS_JOINCONFIG_PAYCO_TH: '페이코 간편가입',
  SNS_JOINCONFIG_CHOOSE: '선택',
  SNS_JOINCONFIG_NAVER_TH: '네이버 간편가입',
  SNS_JOINCONFIG_KAKAO_TH: '카카오 간편가입',
  SNS_JOINCONFIG_KAKAOSYNC_TH: '카카오 싱크',
  SNS_JOINCONFIG_FACEBOOK_TH: '페이스북 간편가입',
  SNS_JOINCONFIG_LINE_TH: '라인 간편가입',
  KAKAOSYNC_DETAIL_DESCRIPTION: '※ 카카오 싱크 상세 연동정보는 카카오 싱크 설정 페이지에서 확인 가능합니다.',
  KAKAOSYNC_INSTALL: '카카오 싱크 설치',
  KAKAOSYNC_DELETE: '카카오 싱크 삭제',
  KAKAOSYNC_SETTING: '카카오 싱크 설정',
  APP_INTRO_TXT: '아래 앱이 사용하는 API와 권한 및 수집하는 고객 정보를 확인하신 후 동의해 주세요.',
  API_USE_PERMISSION: 'API 사용 권한',
  USE_API: '사용 API',
  API_PERMISSION: '권한',
  API_DESCRIPTION: '설명',
  CONSENT_TO_USE: '이용 동의',
  COLLECTED_CUSTOMER_INFORMATION: '수집 고객 정보',
  DO_NOT_AGREE: '동의 안함',
  AGREE_RUN_APP: '동의 및 앱 실행',
  CONTENT_ALL_CONFIRM_AGREE: '위 내용을 모두 확인했으며, 동의합니다.',
  APP_INSTALL_COMPLETE_ALERT: '앱 설치가 완료되었습니다.',
  NO_PERMISSION_AGREE_ALERT: 'API 사용 권한 및 이용 동의에 동의해 주세요.',
  DELETE_CONFIRM_MESSAGE: '카카오 싱크 앱을 삭제하시겠습니까?\n 확인 시 삭제 처리됩니다.',
  APP_DELETE_COMPLETE_ALERT: '삭제되었습니다.',
  READ: '읽기',
  READ_WRITE: '읽기 + 쓰기',

  READ_DESCRIPTION: '조회',
  READ_WRITE_DESCRIPTION: '조회/수정',

  FREE: '무료',
  IN_APP_PURCHASE: '인앱 결제',

  USE: '사용',
  AUTHORITY: '권한',
  DESCRIPTION: '설명',

  PRODUCTION_COMPANY: '제작사',
  AUTHORITY_DESCRIPTION: '{domain} 관련 정보를 {authority}할 수 있습니다.',
  ADMIN_DESCRIPTION: '기본 정보 관리(admin)',
  DELIVERY_DESCRIPTION: '배송(delivery)',
  DISPLAY_DESCRIPTION: '상품 전시(display)',
  MANAGE_DESCRIPTION: '쇼핑몰 운영(manage)',
  MEMBER_DESCRIPTION: '쇼핑몰 회원(member)',
  ORDER_DESCRIPTION: '주문(order)',
  ORDER_FRIENDS_DESCRIPTION: '주문과 관련된 통계, 정산, CS 등',
  PRODUCT_DESCRIPTION: '상품(product)',
  PROMOTION_DESCRIPTION: '프로모션 혜택(promotion)',
  CLAIM_DESCRIPTION: '클레임(claim)',
  WORKSPACE_DESCRIPTION: 'Workspace',

  SNS_URL_TIT: 'SNS 간편 회원가입 로그인 URL 설정',
  SNS_URL_PC: 'PC 웹',
  SNS_URL_MOBILE: '모바일웹',
  SNS_URL_AOS: 'AOS 모바일앱',
  SNS_URL_IOS: 'iOS 모바일',
  SHOPPING_CART_TIT: '장바구니 설정',
  SHOPPING_CART_HIGHLIGHT:
    'ⓘ \'동일 옵션 표기 단위\' 항목은 \'수량 추가\' 방식이 기본이며 변경이 불가합니다. 부득이하게 변경이 필요하다면 shop by 담당자에게 연락해주세요.',
  SHOPPING_CART_TH1: '보관 기간',
  SHOPPING_CART_TH2: '보관 수량',
  SHOPPING_CART_TH3: '동일 옵션 표기 단위',
  SHOPPING_CART_EQUIVALENT_OPTION_UNITTYPE_1: '수량 추가',
  SHOPPING_CART_EQUIVALENT_OPTION_UNITTYPE_2: '행 추가',
  SHOPPING_CART_NOLIMIT: '제한없음',
  SHOPPING_CART_MAX: '최대',
  SHOPPING_CART_MAX_TIP1: '일 까지 보관 가능',
  SHOPPING_CART_MAX_TIP2: '개 까지 보관 가능',
  SHOPPING_CART_POP_CONTENT: '동일한 옵션 추가 시 장바구니에 옵션을 담는 형식에 대한 설정값',
  ACCUMULATIONCONFIG_TIT: '적립금 설정',
  ACCUMULATIONCONFIG_TH1: '상품 적립 사용 여부',
  CONFIRM_PRODUCT_ACCUMULATION_CHANGE:
    '사용 안 함으로 선택 시 등록한 상품의 적립금 사용여부가 \'설정 안 함\'으로 일괄 변경 됩니다.',
  ACCUMULATIONCONFIG_TH2: '회원 적립 혜택 사용 여부',
  CONFIRM_MEMBER_ACCUMULATION_CHANGE:
    '사용 안 함으로 선택 시 등록한 회원등급, 회원그룹의 적립금 사용여부가 \'사용 안 함\'으로 일괄 변경 됩니다.',
  ACCUMULATIONCONFIG_POP_CONTENT: ` <div class="notice_box no_mark">• 적립금 설정은 상품 적립금과 회원 적립금으로 구분되며 선택 시 각 영역에 일괄 적용됩니다.<br><span class="pl-10">- 상품 적립 사용 여부 선택 시 적용되는 위치: 상품등록/수정 &gt; 판매정보 &gt; 적립금 적립</span><br><span class="pl-10">- 회원 적립 혜택 사용 여부 선택 시 적용되는 위치:
  회원관리 &gt; 회원등급 관리/회원그룹 관리 &gt; 등급 적립금 혜택/그룹 적립금
  혜택</span><br><br>• 적립 사용 여부와 관계없이 지급된 적립금은 상품의 '적립금 사용' 설정에 따라 주문 시 적용됩니다.<br>• 적립금 설정은 운영관리
&gt; 적립금 관리에서 상세 설정 하지 않을 경우 '0'으로 적용됩니다.</div>`,
  PRODUCTCONFIG_TIT: '상품 설정',
  PRODUCTCONFIG_HIGHLIGHT: 'ⓘ \'WMS 연동\', \'안전재고 설정(WMS 연동 사용 시)\' 항목은 저장 후 변경이 불가합니다.',
  PRODUCTCONFIG_TH: '카테고리 수수료',
  PRODUCTCONFIG_TH2: '상품상세 URL',
  PRODUCTCONFIG_TH5: '모바일 상품상세 URL',
  PRODUCTCONFIG_TH3: 'WMS 연동',
  WMS_COMPANY_OPTION_CJINEX: '아이넥스(iNEX)',
  PRODUCTCONFIG_COMPANY: '업체명',
  PRODUCTCONFIG_DESCRIPTION: '최초 저장 시, 수정이 불가합니다.',
  PRODUCTCONFIG_TH4: '안전재고 설정',
  STOCK_DISPLAY: '재고 노출',
  STOCK_DISPLAY_POP_CONTENT: `
  <div class="notice_box no_mark">
    • 재고 노출 설정을 ‘노출 안 함＇으로 설정할 경우, API 상에서 해당 쇼핑몰 내 전체 상품의 재고와 판매수량 관련 값이 ‘-999’로 응답합니다. 단, 판매가능재고가 0일 경우 재고수량은 0으로 응답합니다.<br><br/>
    • 쇼핑몰 페이지 구축 시, 품절 처리 및 재고 노출 항목을 체크하셔야합니다. 자세한 사항은 API 문서 내 displayableStock 필드값을 확인해주세요.
  </div>
  `,
  EXPOSED: '노출함',
  DO_NOT_EXPOSE: '노출 안 함',
  PRODUCTCONFIG_SAFETYSTOCKBOUNDARY: 'WMS 연동재고',
  PRODUCTCONFIG_MORETHAN: '개 이상 시, 안전재고',
  PRODUCTCONFIG_LESSTHAN: '미만 시, 안전재고',
  PRODUCTCONFIG_PLACEHOLDER: '숫자만 입력',
  PRODUCTCONFIG_POP_CONTENT: `<div class="notice_box no_mark">
  <div> · 쇼핑몰 운영방식이 스킨이면 URI를, 헤드리스이면 URL을 입력해주세요.</div>
  <div> · 스킨을 변경하면 상품상세 URL이 변경되오니 실제 사용하시는 쇼핑몰의 상품상세 URL을 꼭 확인해 주세요. (ex. 네이버쇼핑 등의 상품 ep 설정, 향상된 사이트맵의 상품 상세 경로 등)</div>
  <div> · 상품번호는 {productNo} 로 입력하세요.</div>
  <div> · 모바일 경로를 별도로 사용중인 경우 '모바일 상품상세 URI'을 추가로 입력하셔야 합니다.</div>
  <div><br> · 예시</div>
  <div>&nbsp;&nbsp;상품상세 URL이 https://nhncommerce.shopby.co.kr/product-detail?productNo=123456789인 경우,</div>
  <div>&nbsp;&nbsp;오로라 스킨이면 /pages/product/product-detail.html?productNo={productNo} 를 입력하세요.</div>
  <div>&nbsp;&nbsp;오로라 리액트 스킨이면 /product-detail?productNo={productNo} 를 입력하세요.</div>
  <div>&nbsp;&nbsp;헤드리스이면 https://nhncommerce.shopby.co.kr/product-detail?productNo={productNo} 를 입력하세요.</div>
</div>`,
  PRODUCTCONFIG_ALERT: 'WMS 연동재고 개수와 같거나 작은 수를 입력해주세요.',
  ORDERCONFIG_TIT: '정산 설정',
  ORDERCONFIG_SETTLEMENT_CONFIG_NOTES: [
    '정산기준시점이란, 파트너에게 정산처리되는 주문상태의 시점으로 파트너의 상품이 포함된 주문이 정산기준시점 주문상태로 변경되는 시점에 파트너 정산금액으로 집계됩니다.',
    '정산 시점이 변경되면 \'기존 정산시점\' 이전 이면서, \'변경된 정산시점\'과 동일하거나 이후인 주문의 정산을 집계합니다.',
    '정산 시점이 변경 되었을 경우 클레임 완료 처리된 옵션을 제외하고 정산에 집계됩니다.'
  ],
  ORDERCONFIG_TH1: '정산유형',
  ORDERCONFIG_SETTLEMENTPERIODTYPE1: '월정산',
  ORDERCONFIG_SETTLEMENTPERIODTYPE2: '주정산',
  ORDERCONFIG_SETTLEMENTPERIODTYPE3: '일정산',
  ORDERCONFIG_TH2: '정산기준시점',
  ORDERCONFIG_SETTLEMENTTARGETSTATUS1: '배송중',
  ORDERCONFIG_SETTLEMENTTARGETSTATUS2: '배송완료',
  ORDERCONFIG_SETTLEMENTTARGETSTATUS3: '구매확정',
  ORDERCONFIG_TH3: '정산예정일(국내파트너)',
  ORDERCONFIG_SPAN1: '매월',
  ORDERCONFIG_SPAN2: '(휴일일 경우',
  ORDERCONFIG_YESTERDAY: '전일',
  ORDERCONFIG_TOMORROW: '익일',
  ORDERCONFIG_LAST_DAY: '말일',
  ORDERCONFIG_SPAN3: '에 지급)',
  ORDERCONFIG_TH4: '지급비율(국내파트너)',
  ORDERCONFIG_TH5: '정산예정일(해외파트너)',
  ORDERCONFIG_TH6: '지급비율(해외파트너)',
  ORDERCONFIG_PAY_TIT: '결제수단 설정',
  ORDERCONFIG_NAVER_PAY_INTRO: '안내 바로가기',
  ORDERCONFIG_NAVER_PAY_DESCRIPTION: 'ⓘ 네이버페이 사용을 위해서 네이버페이 신청/설정에 대한 안내사항을 확인해주세요. ',
  ORDERCONFIG_NAVER_PAY_FRONT_DESCRIPTION:
    'ⓘ 결제수단 설정을 네이버페이 주문형 사용함으로 설정하고, 쇼핑몰 프론트에 연동 개발완료 시 사용 가능합니다.',
  ORDERCONFIG_PAY_HIGHLIGHT:
    'ⓘ 결제수단 설정을 네이버페이 주문형 사용함으로 설정하여도 연동 개발이 먼저 되어있어야 실제 사용이 가능합니다.',
  ORDERCONFIG_PAY_TH1: '네이버페이 주문형',
  ORDERCONFIG_PAY_TH2: '배송비 부과 방식',
  ORDERCONFIG_PAY_BUNDLE_SHIPPING: '묶음배송비',
  ORDERCONFIG_PAY_DELIVERY_TEMPLATE: '배송비템플릿',

  NAVERPAY_CONFIG: '네이버페이 설정',
  NAVERPAY_PAYMENT_EXPOSURE_CONFIG: '네이버페이 결제형 노출 설정',
  NAVERPAY_ORDER_EXPOSURE_CONFIG: '네이버페이 주문형 노출 설정',
  NAVERPAY_CONFIG_GUIDE: '네이버페이 설정 안내',
  NAVERPAY_CONFIG_GUIDE_DESC_1: '간편결제 방식의 결제수단은 각 간편결제 서비스 신청 후 사용이 가능합니다.',
  NAVERPAY_CONFIG_GUIDE_DESC_2:
    '노출설정을 ‘노출 안 함’으로 설정한 결제수단은 쇼핑몰 주문서 작성 페이지에서 결제 수단으로 노출되지 않습니다.',
  NAVERPAY_CONFIG_GUIDE_DESC_3:
    '단, ‘노출 안 함’으로 설정하더라도 클레임 처리 시에는 주문 시 사용한 결제수단을 이용하여 처리가 가능합니다.',
  NAVERPAY_CONFIG_GUIDE_DESC_4: '결제수단 노출설정은 쇼핑몰 반영 시까지 일정 시간이 소요될 수 있습니다.',
  NAVERPAY_CONFIG_GUIDE_POP_CONTENT: ` <div class="notice_box no_mark">
 • 간편결제 방식의 결제수단은 각 간편결제 서비스 신청 후 사용이 가능합니다. <a href='/naverpay-config' target='_blank'>네이버페이 설정 > </a><br>
 • 노출설정을 '노출 안 함'으로 설정한 결제수단은 쇼핑몰 주문서 작성 페이지에서 결제 수단으로 노출되지 않습니다.<br>
 • 단, '노출 안 함'으로 설정하더라도 클레임 처리 시에는 주문 시 사용한 결제수단을 이용하여 처리가 가능합니다.<br>
 • 결제수단 노출설정은 쇼핑몰 반영 시까지 일정 시간이 소요될 수 있습니다.</div>`,

  ORDERCONFIG_DELIVERY_TIT: '주문처리기간 설정',
  ORDERCONFIG_DELIVERY_HIGHLIGHT:
    'ⓘ 네이버페이 주문형 주문 건은 shop by의 주문처리기간 설정을 사용하지 않고, 네이버페이 설정에 따라 적용됩니다.',
  ORDERCONFIG_DELIVERY_TH1: '자동배송완료 (국내배송)',
  ORDERCONFIG_DELIVERY_SPAN1: '국내배송 상품 - 배송시작',
  ORDERCONFIG_DELIVERY_SPAN2: '영업일 이후 자동배송완료 처리함',
  ORDERCONFIG_DELIVERY_TH2: '자동배송완료 (해외배송)',
  ORDERCONFIG_DELIVERY_SPAN3: '해외배송 상품 - 배송시작',
  ORDERCONFIG_DELIVERY_SPAN4: '영업일 이후 자동배송완료 처리함',
  ORDERCONFIG_DELIVERY_TH3: '자동구매확정',
  ORDERCONFIG_DELIVERY_SPAN5: '배송완료',
  ORDERCONFIG_DELIVERY_SPAN6: '일 이후 자동구매확정 처리함',
  ORDERCONFIG_DELIVERY_TH4: '미입금 주문 자동취소',
  ORDERCONFIG_DELIVERY_SPAN7: '주문완료',
  ORDERCONFIG_DELIVERY_SPAN8: '영업일 이후 자동취소 처리함 (주말, 공휴일 제외하고 계산)',
  ORDERCONFIG_DELIVERY_SPAN9: '이후 자동취소 처리함',
  SHIPPINGCONFIG_TIT: '배송 설정',
  SHIPPINGCONFIG_TH: '배송지 입력 URL',
  PAY_TYPE_ACCOUNT: '무통장입금',
  PAY_TYPE_VIRTUAL_ACCOUNT: '가상계좌',

  // 배송지 미입력 주문 자동취소
  DELIVERY_ADDRESS_NOT_ENTERED: '배송지 미입력 주문',
  AUTO_CANCEL: '자동취소',
  AUTO_CANCEL_PROCESSING_AFTER_BUSINESS_DAYS: '영업일 이후 자동취소 처리함',

  // 배송지 입력안내 알림 재발송 시점
  DELIVERY_ADDRESS_ENTER_NOTIFICATION: '배송지 입력안내 알림',
  RESEND_DAYS: '재발송 시점',
  BASED_ON_PAY_DONE: '결제완료일 기준',
  RESEND_AFTER: '이후 재발송',
  SAVE: '쇼핑몰 등록',
  CANCEL: '취소',
  ORDERCONFIG_NAVER_PAY_POP_CONTENT: `<div class="notice_box no_mark">
                              <div class="tit">1. 주문처리</div>
                              <div>샵바이프리미엄와 네이버페이의 주문상태는 주기적으로 자동 동기화가 됩니다.</div>
                              <div>샵바이프리미엄에서 처리 가능한 네이버페이 주문 건 처리는 아래와 같습니다.</div>
                              <div class="pl-10">
                                <div>① 배송준비중 처리: 결제완료 리스트에서 상품준비중으로 상태 변경 시 자동으로 배송준비중 처리가 됩니다.</div>
                                <div>② 배송중(발송) 처리: 송장번호 입력 및 배송중 처리를 할 수 있습니다.</div>
                                <div>③ 취소처리: 결제완료 후 배송 전 주문 건들에 대해 취소처리를 할 수 있습니다.</div>
                                <div>④ 취소승인: 네이버페이에서 구매자 취소 요청 시 취소승인 처리를 할 수 있습니다.</div>
                                <div>⑤ 반품접수: 배송 후 주문 건들에 대해 반품처리를 할 수 있습니다.</div>
                                <div>⑥ 반품거부: 반품접수된 주문 건들에 대해 반품철회 처리를 할 수 있습니다.</div>
                                <div>⑦ 반품보류/보류해제: 반품접수 및 수거완료된 주문 건들에 대해 반품보류/반품보류해제(네이버페이 전용 상태) 처리를 할 수 있습니다.</div>
                                <div>⑧ 반품승인: 반품접수 및 수거완료된 주문 건들에 대해 반품승인을 할 수 있습니다.</div>
                                <div>⑨ 교환거부: 교환신청된 주문 건들에 대해 교환철회 처리를 할 수 있습니다.</div>
                                <div>⑩ 교환수거완료: 교환취소상품의 교환수거완료 처리를 할 수 있습니다.</div>
                                <div>⑪ 교환보류/보류해제: 교환접수 및 수거완료된 주문 건들에 대해 교환보류/교환보류해제(네이버페이 전용 상태) 처리를 할 수 있습니다.</div>
                                <div>⑫ 교환재배송처리: 교환출고상품을 배송중으로 처리할 경우 네이버페이에 교환배송중으로 동기화됩니다.</div>
                              </div>
                              <div>※ 배송완료, 구매확정 처리는 네이버페이에서 처리되며 주기적으로 샵바이프리미엄과 주문상태가 동기화됩니다.</div>
                              <div class="tit">2. 재고처리</div>
                              <div>- 네이버페이 주문 건의 재고 차감 시점: 네이버페이 주문 동기화 후 결제완료 주문 건 인입 시</div>
                              <div>- 네이버페이 주문 건의 재고 복원 시점: 네이버페이에서 취소 처리 완료 / 반품 완료 후 다음 주문상태 동기화 시점에 네이버페이 주문상태 체크 후 처리</div>
                              <div>※ 네이버페이 결제완료 후 주문상태 동기화 사이에 상품이 품절되었다면, 재고가 0인 상태로 네이버페이 주문 건으로 등록되니 주의하시기 바랍니다.</div>
                              <div class="tit">3. 구매평</div>
                              <div>네이버페이 구매평은 각각의 상품의 상품에 상품후기 글로 등록됩니다.</div>
                              <div>이 때 작성자는 "네이버페이 구매자" 로 등록이 됩니다.</div>
                              <div>※ 프리미엄 구매평의 동영상 컨텐츠는 등록되지 않습니다.</div>
                              <div class="tit">4. 기타 이용 안내</div>
                              <div>- 네이버페이 주문형 주문 건은 전체주문조회/주문상세 페이지에서 네이버페이 주문번호와 네이버페이 상품주문번호가 추가 표기됩니다.</div>
                              <div>- 네이버페이 주문형 주문 건은 결제일로부터 3영업일 이내에 발송처리가 불가한 경우, 네이버페이 판매자센터에서 ‘발송지연 안내’ 처리를 하셔야 패널티가 부과되지 않습니다.</div>
                              <div>- 구매자 주문일로부터 75일 이상 출고 처리가 지연된 주문 건은 각각의 주문상태에 따라 90일째 자동 구매확정 또는 고객에게 자동 환불됩니다.</div>
                              <div>- 배송비 및 추가비용의 상세금액은 네이버페이 판매자센터를 통해 확인이 가능합니다. (네이버페이에서 처리한 금액으로 인해 shop by 어드민과 금액이 상이할 수 있습니다.)</div>
                              <div>- 샵바이프리미엄 어드민에서 배송준비중 상태에서 배송보류 처리가 불가합니다. 배송보류 처리가 필요할 경우 네이버페이 판매자센터에서 ‘발송지연 안내’ 처리를 진행해 주세요.</div>
                            </div>`,
  ORDERCONFIG_PAY_POP_CONTENT: ` <div class="notice_box no_mark">
  <ul>
    <li>
      <div>네이버페이 주문형 주문 건은 전체주문조회/주문상세 페이지에서 네이버페이 주문번호와 네이버페이 상품주문번호가 추가 표기됩니다.</div>
    </li>
    <li>
      <div>네이버페이 주문형 주문 건은 결제일로부터 3영업일 이내에 발송처리가 불가한 경우, 네이버페이 판매자센터에서 ‘발송지연 안내’ 처리를 하셔야 패널티가
        부과되지 않습니다.</div>
    </li>
    <li>
      <div>구매자 주문일로부터 75일 이상 출고 처리가 지연된 주문 건은 각각의 주문상태에 따라 90일째 자동 구매확정 또는 고객에게 자동 환불됩니다.</div>
    </li>
    <li>
      <div>배송비 및 추가비용의 상세금액은 네이버페이 판매자센터를 통해 확인이 가능합니다. (네이버페이에서 처리한 금액으로 인해 shop by 어드민과 금액이 상이할 수
        있습니다.)</div>
    </li>
    <li>
      <div>shop by 어드민에서 배송보류 처리가 불가합니다. 배송보류 처리가 필요할 경우 네이버페이 판매자센터에서 '발송지연 안내'처리를 진행해 주세요.</div>
    </li>
    <li>
      <div>네이버페이 주문형 주문 건은 통계 데이터에 집계되나, 정산 데이터에는 집계되지 않습니다. 따라서 통계와 매출내역 조회 메뉴의 금액이 상이할 수
        있습니다.</div>
    </li>
    <li>
      <div>네이버페이 주문형 주문의 정산은 네이버페이 판매자센터에서 제공하는 정산 자료를 사용해 주세요.</div>
    </li>
  </ul>
</div>`,
  ORDERCONFIG_DELIVERY_POP_CONTENT: `<div class="notice_box no_mark">
<ul>
  <li>
    <div>네이버페이 주문형 주문 건은 shop by의 배송비 산출 기본 정책을 따르지 않고 선택한 별도 부과 방식에 따라 배송비가 책정됩니다.</div>
  </li>
  <li>
    <div>부과 방식에 따라 네이버페이 주문서와 쇼핑몰 주문서의 초도 배송비와 클레임 배송비가 상이할 수 있습니다.</div>
  </li>
  <li>
    <div>사용중인 부과 방식을 변경할 경우 1) 네이버페이 주문서로 연동 시점, 2) 네이버페이 주문 후 shop by로 주문데이터를 연동하는 시점에서 네이버페이와
      shop by의 배송비가 다르게 부과 및 인식될 수 있습니다. 검토 후 변경해 주세요.</div>
  </li>
  <li>
    <div>묶음배송비: 상품의 배송비템플릿이 속한 묶음 그룹 단위로 최소 기준 배송비를 한번 부과하는 방식입니다. (shop by 배송비 산출 방식과 다름)</div>
  </li>
  <li>
    <div>배송비템플릿: 묶음 그룹과 관계없이 각 상품의 배송비템플릿 기준으로 배송비를 각각 계산하여 부과하는 방식입니다.</div>
  </li>

  <div>[1. 최대부과 예시]</div>
  <div>조건) 상품A: 유료 배송(3000원)/ ’가’ 묶음그룹, 상품B: 조건부 무료 배송(2500원)/ ’가’ 묶음그룹</div>
  <div>- 묶음배송비 선택 시 네이버페이 배송비: 2500원 부과, 쇼핑몰 배송비: 3000원 부과</div>
  <div>- 배송비템플릿 선택 시 네이버페이 배송비: 5500원 부과(3000원+2500원), 쇼핑몰 배송비: 3000원 부과</div>
  <div>[2. 최소부과 예시]</div>
  <div>조건) 상품A: 유료 배송(3000원)/ ’나’ 묶음그룹, 상품B: 조건부 무료 배송(2500원)/ ’나’ 묶음그룹</div>
  <div>- 묶음배송비 선택 시 네이버페이 배송비: 2500원 부과, 쇼핑몰 배송비: 2500원 부과</div>
  <div>- 배송비템플릿 선택 시 네이버페이 배송비: 5500원 부과(3000원+2500원), 쇼핑몰 배송비: 2500원 부과</div>
</ul>
</div>`,
  SHIPPINGCONFIG_POP_CONTENT: `<div class="notice_box no_mark">
<div>배송지 입력 URL은 주문 후 배송지를 나중에 입력하는 페이지 URL이며</div>
<div>배송지 관련 코드 부분을 \${encryptedShippingNo} 라고 입력하세요. </div>
<div><br>(예시)</div>
<div>배송지 입력 URL이 <span>http://shoppingmall.com/orders/shipping-info?code=abcd1234</span> 인 경우</div>
<div><span>http://shoppingmall.com/orders/shipping-info?code=\${encryptedShippingNo}</span> 로 입력하세요.</div>
</div>`,
  NO_MALLNAME_ALERT: '쇼핑몰명을 입력하세요.',
  NO_LANGUAGE_ALERT: '언어를 최소 하나 이상 설정해주세요.',
  NO_SCEMAIL_ALERT: '고객센터 이메일 주소를 입력하세요.',
  NO_OBEMAIL_ALERT: '발송전용 이메일 주소를 입력하세요.',
  NO_COUNTRY_ALERT: '국가를 선택해주세요.',
  NO_MAX_AMOUNT_ALERT: '최대 주문금액을 입력해주세요.',
  NO_TIMEZONE_ALERT: '시간대를 선택해주세요.',
  NO_FIRST_ACCOUNT_ALERT: '첫번째 계좌번호를 반드시 입력해주세요.',
  NO_ACCOUNT_BANKACCOUNT_ALERT: '입력하신 계좌정보를 확인해주세요.',
  NO_ACCOUNT_BANK_ALERT: '입력하신 계좌정보의 은행을 선택해주세요.',
  NO_SCPHONE_ALERT: '고객센터 전화번호를 입력하세요.',
  NO_PRODUCT_URL_ALERT: '상품상세 URL을 입력해주세요.',
  NO_CORRECT_PRODUCT_URL_ALERT: '상품상세 URL을 정확히 입력해주세요. (상품상세 URL 입력 안내 참고)',
  NO_CORRECT_PRODUCT_MOBILE_URL_ALERT: '모바일 상품상세 URL을 정확히 입력해주세요. (상품상세 URL 입력 안내 참고)',
  NO_JOIN_ALERT: '최소 1개의 가입설정은 사용함으로 선택해주세요. (쇼핑몰회원, 간편회원)',
  NO_JOIN_CONTENT_ALERT: '선택한 간편가입의 정보를 입력해주세요.',
  NO_WMSUSED_CONFIG_ALERT: '안전재고 설정값을 입력하세요.',
  ADD_MALL_CONFIRM: '쇼핑몰 등록을 완료하시겠습니까?',
  NO_PERSONALINFO_OR_MARKETINGINFO_NOTICEDAY_ALERT: '자동발송 일자를 선택해주세요.',
  NO_SHIPPINGCONFIG_URL_ALERT: '배송지 입력 URL을 정확히 입력해주세요. (배송지 입력 URL 안내 참고)',
  NO_CONTRACT_TITLE_ALERT: '계약 서류를 형식에 맞게 입력해주세요.',
  NO_NAVER_PAY_MERCHANT_ID: '네이버페이센터 가맹정 ID를 입력해주세요',
  NO_NAVER_PAY_CERTI_KEY: '가맹점 인증키를 입력해주세요',
  NO_NAVER_PAY_BUTTON_KEY: '버튼 인증키를 입력해주세요',
  MAX_FILE_SIZE_ALERT: '파일용량이 10MB를 초과하였습니다.',
  SMS_AND_MAIL_CONFIG_ALERT: 'SMS 발신번호 등록이 완료 된 후, e-mail 발송 사용안함 설정이 가능합니다.',
  UPLOAD_FILE_ALERT: '파일을 업로드 해주세요.',
  CONFIG_USED_CHANGE_CONFIRM: '변경 시 더이상 쇼핑몰 회원으로 가입할 수 없습니다.',
  CANCEL_CONFIRM: '쇼핑몰 수정을 취소하시겠습니까?\n입력하신 내용은 저장되지 않습니다.',
  DELETE_CONTRACT_CONFIRM: '입점 표준계약서를 삭제하시겠습니까?',
  ADD_SEND_NO_ALERT: '쇼핑몰 등록 후, 발신번호 등록이 가능합니다.',
  ADD_MALL_SUCCESS_ALERT: '신규 쇼핑몰이 정상 등록되었습니다.',
  ADD_MALL_CANCEL_CONFIRM: '쇼핑몰 등록을 취소하시겠습니까?',
  MOBILEAPP_POP_CONTENT: `<div class="notice_box no_mark" style="line-height:15px;">• 신청완료 되시면 쇼핑몰관리 &gt; 쇼핑몰수정&gt; 모바일앱 관리 &gt;모바일앱 관리 바로가기 버튼이
  노출됩니다.<br>• 모바일앱 관리 사용요금은 shop by 사용요금과 별도로 추가 부과됩니다.<br>• 모바일앱 (Mobile App) 작업을 위해서는 모바일웹 (Mobile
  Web) 도메인 정보가 필요합니다.<br>• 모바일앱 관리 신청 완료 하시면 모바일앱 관리 메뉴 접속이 가능하십니다.</div>`,
  STANDING_POINT_TH: '입점 표준 계약서',
  STANDING_POINT_REGISTER: '등록',
  STANDING_POINT_UPDATE: '변경',
  STANDING_POINT_DELETE: '삭제',
  STANDING_POINT_DESCRIPTION: '파트너사 입점 계약 시, 동의 받을 계약 내용을 등록할 수 있습니다.',
  BANK_EDIT: '계좌정보수정',
  PERSONALINFO_TIT: '개인정보 이용내역 안내 발송 설정',
  PERSONALINFO_HIGHLIGHT1:
    'ⓘ 개인정보 이용안내 고지 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 30조 2 (개인정보 이용내역의 통지) 에 의거하여개인정보 이용내역 안내를 매년1회 회원에게 발송 해야합니다.',
  PERSONALINFO_HIGHLIGHT2:
    'ⓘ 운영관리>e-mail 관리>자동 e-mail 설정 에서 해당 템플릿 ‘사용’ 인 경우만 설정된 자동발송일자가 적용되어발송 됩니다.',
  PERSONALINFO_HIGHLIGHT3:
    'ⓘ 자동발송일자는 한번 저장 후 변경이 불가합니다. 부득이하게 변경이 필요하시면 shop by 담당자에게 연락해주세요.',
  PERSONALINFO_TH: '자동발송 일자 설정',
  PERSONALINFO_SPAN1: '매달',
  PERSONALINFO_SPAN2: '설정',
  DAY_LIST_OPTION_SELECT: '일선택',
  DAY_LIST_OPTION_1: '1일',
  DAY_LIST_OPTION_2: '2일',
  DAY_LIST_OPTION_3: '3일',
  DAY_LIST_OPTION_4: '4일',
  DAY_LIST_OPTION_5: '5일',
  DAY_LIST_OPTION_6: '6일',
  DAY_LIST_OPTION_7: '7일',
  DAY_LIST_OPTION_8: '8일',
  DAY_LIST_OPTION_9: '9일',
  DAY_LIST_OPTION_10: '10일',
  DAY_LIST_OPTION_11: '11일',
  DAY_LIST_OPTION_12: '12일',
  DAY_LIST_OPTION_13: '13일',
  DAY_LIST_OPTION_14: '14일',
  DAY_LIST_OPTION_15: '15일',
  DAY_LIST_OPTION_16: '16일',
  DAY_LIST_OPTION_17: '17일',
  DAY_LIST_OPTION_18: '18일',
  DAY_LIST_OPTION_19: '19일',
  DAY_LIST_OPTION_20: '20일',
  DAY_LIST_OPTION_21: '21일',
  DAY_LIST_OPTION_22: '22일',
  DAY_LIST_OPTION_23: '23일',
  DAY_LIST_OPTION_24: '24일',
  DAY_LIST_OPTION_25: '25일',
  DAY_LIST_OPTION_26: '26일',
  DAY_LIST_OPTION_27: '27일',
  DAY_LIST_OPTION_28: '28일',
  PERSONALINFO_HIGHLIGHT4: '회원가입 이후 매년 1년 이내 해당월 설정한 일자에 발송처리 됩니다.',
  MARKETINGINFO_TIT: '마케팅 수신동의 이용현황 발송 설정',
  MARKETINGINFO_HIGHLIGHT1:
    'ⓘ 마케팅수신동의 이용현황 안내 : 광고성 메일/SMS/푸시 수신동의 정보통신망법에 의거 2년마다 회원 대상으로 발송 해야합니다.',
  MARKETINGINFO_HIGHLIGHT2:
    'ⓘ 운영관리>e-mail 관리>자동 e-mail 설정 에서 해당 템플릿 ‘사용’ 인 경우만 설정된 자동발송일자가 적용되어발송 됩니다.',
  MARKETINGINFO_HIGHLIGHT3:
    'ⓘ 자동발송일자는 한번 저장 후 변경이 불가합니다. 부득이하게 변경이 필요하시면 shop by 담당자에게 연락해주세요.',
  MARKETINGINFO_HIGHLIGHT4: '마케팅 수신동의일자 기준으로 2년 내 해당월 설정한 일자에 발송처리 됩니다.',
  API_TIT: '개발 연동 정보',
  API_HIGHLIGHT1: 'ⓘ 클라이언트 아이디: 프론트에서 API 호출 시 해당하는 쇼핑몰을 판단할 수 있는 key값',
  API_HIGHLIGHT2: 'ⓘ 외부연동 키: 외부 서버에서 shop by의 서버 호출 시 판단할 수 있는 key값',
  API_HIGHLIGHT3: 'ⓘ API 점검: API 점검 등의 이유로 클라이언트 접근을 막아야 할 때 사용',
  API_TH1: '클라이언트 아이디',
  API_TH2: '외부 연동 키',
  API_TH3: 'API 점검',
  API_BTN: 'API 점검 진행',
  EDIT_BTN: '변경사항 저장',
  SENDNO_POPUP_TH: '발신번호',
  SENDNO_POPUP_DESCRIPTION1: '유선 전화번호: 02-YYY-YYYY (지역 번호 포함하여 등록)',
  SENDNO_POPUP_DESCRIPTION2: '대표 전화번호: 15YY, 16YY, 18YY (번호 앞에 지역 번호 사용 금지)',
  SENDNO_POPUP_DESCRIPTION3: '공통 서비스 식별 번호: 0N0 (번호 앞에 지역번호 사용 금지)',
  SENDNO_POPUP_DESCRIPTION4: '최소 8자리 ~ 최대 11자리까지의 발신 번호 입력 가능',
  SENDNO_POPUP_DESCRIPTION5: '존재하지 않는 번호 대역으로 메시지 전송 불가',
  SENDNO_POPUP_DESCRIPTION6: '(예: 070-0YYY, 070-1YYY, 010-0YYY, 010-1YYY)',
  SENDNO_POPUP_TH2: '통신서비스 이용 증명원',
  SENDNO_POPUP_DESCRIPTION7: '등록할 발신번호에 해당하는 통신서비스 이용 증명원을 첨부하시기 바랍니다.',
  SENDNO_POPUP_DESCRIPTION8: '통신서비스 이용 증명원이란, 이용자 본인이 사용하는 번호임을 증명하는 서류입니다.',
  SENDNO_POPUP_DESCRIPTION9:
    '가입한 통신사의 고객센터에서 발급받을 수 있으며, 자세한 발급방법은 해당 통신사에 문의하시기 바랍니다.',
  SENDNO_POPUP_DESCRIPTION10: '담당자가 등록한 서류 심사 후 영업일 기준 1~2일 내 승인이 완료됩니다.',
  SENDNO_POPUP_DESCRIPTION11: '발신번호를 추가로 등록하실 경우, 등록완료 되기 전까지 기존 발신번호로 발송되며',
  SENDNO_POPUP_DESCRIPTION12: '등록 완료 후 부터 추가한 발신번호로 발송됩니다.',
  SENDNO_POPUP_PLACEHOLDER: '등록할 발신번호를 입력해주세요.',
  SENDNO_POPUP_ADDFILE: '파일찾기',
  SENDNO_POPUP_DOWNLOADFILE: '다운로드',
  SENDNO_POPUP_CONFIRM: '발신번호 등록 요청',
  SENDNO_POPUP_LP_TITLE: '발신번호 등록내역',
  SENDNO_POPUP_LP_TH1: '등록요청 일시',
  SENDNO_POPUP_LP_TH2: '발신번호',
  SENDNO_POPUP_LP_TH3: '상태',
  SENDLIST_REGISTRATION_COMPLETED: '등록완료',
  SENDLIST_RE_REQUEST: '재등록요청',
  SENDLIST_REQUEST: '등록요청',
  SENDLIST_DENIED: '등록 불가',
  REQUESTSENDNO_TIT: '발신번호 등록하기',
  CARTPOPUP_TIT: '동일 옵션 표기 단위',
  ACCUMULATIONPOPUP_TIT: '적립금 설정',
  PRODUCTPOPUP_TIT: '상품상세 URL 안내',
  STOCKDISPLAYPOPUP_TIT: '재고 노출 안내',
  ORDERPAYPOPUP_TIT: '네이버페이 주문형 이용 안내',
  ORDERDELIVERYPOPUP_TIT: '네이버페이 주문형 배송비 부과 방식 설정 안내',
  SHIPPINGPOPUP_TIT: '배송지 입력 URL 안내',
  MOBILEAPPGUIDANCEPOPUP_TIT: '모바일 앱 관리 안내',
  INSTAGRAMGUIDANCEPOPUP_TIT: '인스타그램 연동 안내',
  INSTAGRAMGUIDANCEPOPUP_CONTENT:
    '쇼핑몰 대표 인스타그램 계정을 생성 후, 인스타그램 연동을 하면 게시물을 쇼핑몰에 노출 시킬 수 있습니다.\n' +
    '인스타그램 게시글은 최대 12개 노출되며 1시간마다 자동 갱신됩니다.\n' +
    '인스타그램 계정 문제로 연동이 실패한 경우 연동 해제 될 수 있습니다.\n' +
    '연동 해제 시 다시 연동을 시도해주세요.',
  STANDING_POPUP_TITLE: '입점 표준계약서',
  STANDING_POPUP_HIGHLIGHT:
    'ⓘ 입력된 ‘입점 표준계약서’ 의 내용은 ‘파트너 등록’ 시, 파트너사에 따라 적용 또는 수정할 수 있습니다.',
  STANDING_POPUP_TH: '내용',
  STANDING_POPUP_SUCCESS_MSG: '저장되었습니다.',
  STANDING_POPUP_ERR_CONTENT_NULL: '내용을 입력해 주세요.',
  EDIT_SAVE_ALERT: '변경 된 내용을 저장하시겠습니까?',
  MODIFY_SAVE_SUCESS_ALERT: '쇼핑몰 수정 완료',

  SMS_SEND_NOTICE_1:
    'Ⓘ 의무대상자에 한해 관련 법령에 따라 정보주체 외 개인정보 수집 시 정보주체의 요구가 없더라도 수집출처 등을 안내하여야 합니다.',
  SMS_SEND_NOTICE_2:
    'Ⓘ 회원연동 시 \'정보주체 외 개인정보 수집 설정\' 항목을 체크하여야 수집출처 알림 발송이 가능합니다.',
  SMS_SEND_NOTICE_3: 'Ⓘ 상세 내용은 <a class="oauth_type_button">[여기]</a>에서 확인 가능합니다.',

  TO_COLLECT_PERSONAL_INFORMATION_CONFIGURATION: '회원연동 시 <br />개인정보 수집 설정',
  SOURCE_OF_COLLECTION: '수집출처',

  RECURRING_PAYMENT_CONFIG_TIT: '정기결제(배송) 설정',
  RECURRING_PAYMENT_KCP: 'KCP 정기결제(배송)',
  RECURRING_PAYMENT_CONFIG_NO_INPUT_ALERT_MSG: '정기결제 정보를 입력해주세요',

  PLZ_INSERT_SOURCE_OF_COLLECTION: '수집출처를 입력해주세요.',

  NOTICE_TO_COLLECT_PERSONAL_INFORMATION_TITLE: '알림 발송 설정',
  COLLECTION_OF_PERSONAL_INFORMATION: '정보주체 외 개인정보 수집',

  JOIN_APPROVE_CONFIG: '회원가입 승인 사용설정',
  APPROVE_NOT_USED: '승인 절차 없이 가입',
  APPROVE_USED: '승인 후 가입',
  JOIN_APPROVE_CONFIG_TOOLTIP_1: `· '승인 후 가입' 설정 시 회원가입한 후, 운영자가 회원가입 승인 처리를 하면 회원가입 완료 상태로 변경됩니다.
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_2: `· '승인 후 가입' 설정 시 회원은 승인대기 상태로 등록되며, 운영자가 승인 처리를 하지 않은 경우 <span style="color: red">승인대기 상태 회원은 회원가입일 기준 60일 경과 후 삭제 처리</span>됩니다.
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_3: `· '승인 후 가입' 으로 설정한 상태에서 '승인 절차 없이 가입' 으로 변경 시 승인대기 상태인 회원은 자동으로 승인 처리되지 않으므로 승인이 필요한 경우 수동으로 승인 처리가 필요합니다.
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_4: `· '승인 후 가입' 설정 시 SMS, 이메일 알림은 '회원가입 승인완료' 템플릿 사용여부를 설정하여 발송 가능합니다.
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_5: `- 이메일 사용설정 : <a href="/mail/dispatch" target="_blank">설정 바로가기></a>
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_6: `- SMS 사용설정 : <a href="/member/message/config" target="_blank">설정 바로가기></a>
  `,
  JOIN_APPROVE_CONFIG_TOOLTIP_7: `- 알림톡 사용설정 : <a href="/member/message/config" target="_blank">설정 바로가기></a>
  `,
  EXCLUDE_AUTO_BUY: '서비스상품군 자동 구매확정 대상에서 제외',
  EXCLUDE_AUTO_BUY_CONFIRM:
    '서비스상품군 자동 구매확정 대상에 포함 시 이전 생성된 서비스상품군에 대한 주문도 설정된 기간에 따라 자동 구매확정 처리됩니다. 서비스상품군을 처리 대상에 포함하시겠습니까?',
  AOS_MOBILE_DEEP_LINK: 'AOS 모바일 딥링크',
  IOS_MOBILE_DEEP_LINK: 'IOS 모바일 딥링크',
  AOS_MOBILE_POPOVER_CONTENT: `<div class="notice_box no_mark" style="line-height:20px;">
  - Android 앱 링크 인증을 위해 assetlinks.json 파일을 업로드 해 주세요.<br>
  - 파일명과 확장자가 일치하여야 정상 업로드 가능합니다.<br>
  - 대표로 지정하신 도메인에 보안서버가 설치되지 않을 경우 업로드가 불가합니다.<br>
  - json 이외의 확장자 파일은 업로드 불가합니다.<br>
  - 도메인이 변경될 경우 파일 내 도메인 정보를 업데이트하여 재 업로드를 해주셔야 변경된 도메인으로 인증 가능합니다.<br>
  - 파일 업로드 외 딥링크 관련 문제 발생 시 모바일 APP 구축사로 문의해주세요.
  </div>`,
  IOS_MOBILE_POPOVER_CONTENT: `<div class="notice_box no_mark" style="line-height:20px;">
  - ios 앱 링크 인증을 위해 apple-app-site-association 파일을 json 형태로 업로드 해 주세요.<br>
  - 파일명과 확장자가 일치하여야 정상 업로드 가능합니다.<br>
  - 대표로 지정하신 도메인에 보안서버가 설치되지 않을 경우 업로드가 불가합니다.<br>
  - json 이외의 확장자 파일은 업로드 불가합니다.<br>
  - 도메인이 변경될 경우 파일 내 도메인 정보를 업데이트하여 재 업로드를 해주셔야 변경된 도메인으로 인증 가능합니다.<br>
  - 파일 업로드 외 딥링크 관련 문제 발생 시 모바일 APP 구축사로 문의해주세요.
  </div>`,
  DOMAIN_SSL_NOT_INSTALLED: '보안서버가 설치되지 않은 도메인입니다.',
  CHECK_FILE_NAME: '파일명을 다시 확인해주세요.',

  PAYMENT_SETTING_TITLE: '결제수단 노출설정',
  PAYMENT_SETTING_REALTIME_ACCOUNT_TRANSFER: '계좌이체',
  PAYMENT_SETTING_CREDIT_CARD: '신용카드',
  PAYMENT_SETTING_VIRTUAL_ACCOUNT: '가상계좌',
  PAYMENT_SETTING_ESCROW_VIRTUAL_ACCOUNT: '가상계좌',
  PAYMENT_SETTING_ESCROW_REALTIME_ACCOUNT_TRANSFER: '계좌이체',
  PAYMENT_SETTING_MOBILE: '휴대폰',
  PAYMENT_SETTING_ESCROW: '에스크로결제',
  PAYMENT_SETTING_GENERAL_PAY: '일반결제',
  PAYMENT_SETTING_EASY_PAY: '간편결제',
  PAYMENT_SETTING_PAYCO: 'PAYCO',
  PAYMENT_SETTING_EASY_PAYCO: 'PAYCO',
  PAYMENT_SETTING_NAVER_EASY_PAY: '네이버페이 결제형',
  PAYMENT_SETTING_NAVER_PAY: '네이버페이 주문형',
  PAYMENT_SETTING_ACCOUNT: '무통장 입금',
  PAYMENT_SETTING_PAYCO_POINT: '페이코 포인트',
  PAYMENT_SETTING_NOTICE_TITLE: '결제수단 노출 설정 안내',
  PAYMENT_SETTING_NOTICE_1: '· 일반결제/에스크로결제 방식의 결제수단은 전자결제(PG) 서비스 신청 후 사용이 가능합니다. <a href="/pg" target="_blank">전자결제(PG) 설정></a>',
  PAYMENT_SETTING_NOTICE_3:
  '· 노출설정을 ‘노출 안 함’으로 설정한 결제수단은 쇼핑몰 주문서 작성 페이지에서 결제 수단으로 노출되지 않습니다.',
  PAYMENT_SETTING_NOTICE_4:
  '· 단, ‘노출 안 함’으로 설정하더라도 클레임 처리 시에는 주문 시 사용한 결제수단을 이용하여 처리가 가능합니다.',
  PAYMENT_SETTING_NOTICE_5:
    '· 결제수단 노출설정은 쇼핑몰 반영 시까지 일정 시간이 소요될 수 있습니다.',
  NAVER_PAY_ALERT: '네이버페이 사용여부가 ‘사용 안 함’상태로\n결제수단 노출설정이 불가합니다.',
  PAY_TYPE_ALERT: '노출설정 불가 : {0} - {1}\n쇼핑몰에 연동되지 않은 결제수단은 노출설정이 불가합니다.\n새로고침 후 다시 시도해주세요.',
});
